import { useEffect, useState } from "react";
import JwtDecode from "jwt-decode";
import getAuthToken from "helpers/getAuthToken";
import { UserData } from "types/user.types";

function useUserData(): UserData | null {
  const [userData, setUserData] = useState<UserData | null>(null);

  async function getUserData() {
    const token = await getAuthToken();
    if (token) {
      const data = JwtDecode<UserData>(token);
      if (data) {
        setUserData(data);
      }
    }
  }

  useEffect(() => {
    getUserData();
  }, []);

  return userData;
}

export default useUserData;
